module.exports = __webpack_public_path__ + "img/192.c2766f12.jpg";